import { Customer } from 'types/Customer';
import { Pet } from 'types/Pet';

export interface IntakeFormState {
    loading: boolean;
    step: IntakeFormStep;
    customer: Customer;
    pets: Array<Pet>;
}

export enum IntakeFormStep {
    Initial,
    CustomerForm,
    AddPetForm,
    PetList,
    Success
}
